"use client";

import { ResponsiveModal } from "@/components/responsive-modal";
import { useI18n } from "@/locales/client";
import useMoveFolderModal from "../hooks/use-add-to-folder-modal";
import { ManageFoldersForm } from "./manage-folders-form";

export const AddToFolderModal = () => {
  const t = useI18n();
  const { isOpen, onClose } = useMoveFolderModal();

  return (
    <ResponsiveModal
      open={isOpen}
      onOpenChange={onClose}
      title={t("manageFolders")}
      description={t("manageFoldersDescription")}
      form={<ManageFoldersForm />}
    />
  );
};
